module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n\t[(ngModel)]=\"value\"\r\n\t[disabled]=\"isDisabled\">\r\n\t<option [value]=\"null\">{{nullLabel}}</option>\r\n\t<option [value]=\"true\">{{trueLabel}}</option>\r\n\t<option [value]=\"false\">{{falseLabel}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-bool-picker/ztsi-bool-picker.component.html
// module id = ./src/app/components/shared/ztsi-bool-picker/ztsi-bool-picker.component.html
// module chunks = main